import { useContext, useEffect } from "react"
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { GlobalContext } from "../Context/globalContext";
import { AiOutlineMenu } from 'react-icons/ai';
import { LogoutApi } from "../Services/userServices";

export const Header = () => {

    const globalContext = useContext(GlobalContext);
    const navigate = useNavigate();

    useEffect(() => {
        const logged = globalContext.loggedIn
        if (!logged) {
            sessionStorage.clear();
            navigate('/');
            return false
        }
    }, [])

    const logout = (e) => {
        globalContext.setLoader(true);
        LogoutApi().then(res => {
            sessionStorage.clear();
            globalContext.setLoader(false);
            globalContext.setLoggedIn(false);
            navigate('/');
            setTimeout(() => { toast.success('Logged Out Successfully.'); }, 500);
        }).catch(err => {
            globalContext.setLoader(false);
            sessionStorage.clear();
            globalContext.setLoggedIn(false);
            navigate('/');
            setTimeout(() => { toast.success('Logged Out Successfully.'); }, 500);
        })
    }

    return (
        <header id="header" className="header fixed-top d-flex align-items-center">
            <div className="d-flex align-items-center justify-content-between">
                <a className="logo d-flex align-items-center">
                    <img src="assets/img/logo.png" alt="" />
                    <span className="d-none d-lg-block">Admin</span>
                </a>
                <AiOutlineMenu className="toggle-sidebar-btn" onClick={(e) => document.body.classList.toggle('toggle-sidebar')} />
            </div>
            <nav className="header-nav ms-auto">
                <ul className="d-flex align-items-center">
                    <li className="nav-item dropdown pe-3">
                        <a className="nav-link nav-profile d-flex align-items-center pe-0" style={{ cursor: "pointer" }} data-bs-toggle="dropdown">
                            <img src={require('../Assets/img/2.png')} alt="Profile" className="rounded-circle" />
                        </a>
                        <ul className="dropdown-menu dropdown-menu-end dropdown-menu-arrow profile">
                            <li className="dropdown-header">
                                {globalContext.email}
                            </li>
                            <li>
                                <hr className="dropdown-divider" />
                            </li>
                            <li>
                                <a className="dropdown-item d-flex align-items-center drop-options" onClick={() => navigate('/settings')}>
                                    <i className="bi bi-person"></i>
                                    <span>Settings</span>
                                </a>
                            </li>
                            <li>
                                <hr className="dropdown-divider" />
                            </li>
                            <li>
                                <a className="dropdown-item d-flex align-items-center drop-options" onClick={(e) => logout(e)}>
                                    <i className="bi bi-box-arrow-right"></i>
                                    <span>Sign Out</span>
                                </a>
                            </li>
                        </ul>
                    </li>
                </ul>
            </nav >
        </header >
    )

}